import React from 'react';
import { Spin } from 'antd';
import './styles.less';

const SpinnerCentered = ( { margin = '50' } ) => {
    return (
        <div className="spinner-centered">
            <Spin 
                size="medium"
                style={ { 
                    marginTop: `${ margin }px`,
                    marginBottom: `${ margin }px`
                } } 
            />   
        </div>
    );
};

export default SpinnerCentered;
